import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ClinicalIndustry from "@/pages/ClinicalIndustry";

export const Route = createFileRoute("/es/servicios/clinical-solutions/estudios-de-rendimiento-clínico-de-ivd")({
  head: () => buildRouteHead("/es/servicios/clinical-solutions/estudios-de-rendimiento-clínico-de-ivd", {
      title: "Estudios de Rendimiento Clínico de IVD — Clinical Solutions | QbD Group",
      description: "Diseñamos y ejecutamos estudios de rendimiento clínico de IVD conformes al IVDR: protocolo, selección de centros, análisis de datos e informes.",
    }),
  component: ClinicalIndustry,
});

